module.exports = __webpack_public_path__ + "img/water02.458e2043.png";